import { Icon, Icons } from '@Components/icon/Icon';
import { RoutesMap } from '@Router/router.types';
import { useNavigationManager } from '@Router/useNavigationManager';

export const MobileBackButton = ({ isFirstStep }: { isFirstStep?: boolean }) => {
  const { navigateToPreviousPage, navigateToSpecificPage } = useNavigationManager();
  // if isFirstStep is true, navigate to Login page
  const handleClick = () => {
    if (isFirstStep) {
      navigateToSpecificPage(RoutesMap.WELCOME);
    } else {
      navigateToPreviousPage();
    }
  };
  return (
    <Icon
      icon={Icons.Arrow}
      className='md:hidden block absolute top-[20px] rotate-180 left-[16px] z-50 w-[26px]'
      onClick={handleClick}
    />
  );
};
